<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Infos TPE Remontées</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-btn @click="onexport" block class="custom-btn white--text" color="#00BCD4" height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export infos</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>

    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "infosTPE",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      lastHighlitedRow: null,
      loading: false,
      toObject: [],
      file: "",
      excelData: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: true,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders: [
          "Id", "Numéro TPE", "Affectation", "Date remontée", "Batterie", "GPS", "Date création"
        ],
        columns: [
          {title: "Id", width: "80px"},
          {title: "Numéro TPE", width: "100px"},
          {title: "Affectation", width: "100px"},
          {
            title: "Date remontée",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date"
          },
          {title: "Batterie", width: "200px"},
          {title: "GPS", width: "160px"},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
        ]
      }
    }
  },
  created() {
    this.getData()
  },

  methods: {
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    getData() {
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/infosTPE/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["numeroTPE"],
                item["affectation"],
                moment(item["dateHeure"]).format("DD-MM-YYYY HH:mm:ss"),
                item["infosBattery"],
                item["gpsCoordinates"],
                moment(item["creationDate"]).format("DD-MM-YYYY HH:mm:ss")
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData(this.depthVal)
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },

    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Infos_TPE_remontés") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Infos_TPE_remontés.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },
  },
};
</script>
<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}
</style>
 
